import clsx from "clsx";

type Props = {
    title: string;
    active?: boolean;
    onClick: () => void;
}

export const HelpCenterButton = ({ title, active, onClick }: Props) => (
    <button type="button" className={clsx("help-center-section", { 'active': active })} onClick={onClick}>
        { title }
    </button>
)